import React from "react";
import {LocationNameLoading} from "@components/Booking/LocationSelection/LocationRow/Contents/LocationInfo/LocationName";
import {FullAddressLoading} from "@components/Booking/LocationSelection/LocationRow/Contents/LocationInfo/FullAddress";
import {TimeInfoLoading} from "@components/Booking/LocationSelection/LocationRow/Contents/LocationInfo/TimeInfo";

const LocationInfoLoading = () => {
  return (
    <div className="flex-grow">
      <LocationNameLoading />
      <FullAddressLoading />
      <TimeInfoLoading />
    </div>
  );
};

export default React.memo(LocationInfoLoading);
